var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNettoyage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 100",
    style: {
      enableBackground: "new 0 0 125 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.3,21.8c-1.6,0-2.7,1.1-2.7,2.7s1.1,2.7,2.7,2.7S93,26,93,24.5S91.9,21.8,90.3,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.1,30.9c-1.6,0-2.7,1.1-2.7,2.7s1.1,2.7,2.7,2.7s2.7-1.1,2.7-2.7C104.8,32.3,103.4,30.9,102.1,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.1,14c-1.6,0-2.7,1.1-2.7,2.7s1.1,2.7,2.7,2.7s2.7-1.1,2.7-2.7S103.4,14,102.1,14z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.8,12.6H33c-0.2,0-0.7,0-0.9,0.2l-11.4,8.9c-0.7,0.7-0.7,1.3,0,2l12,12v8.3h-5.4c-0.7,0-1.3,0.7-1.3,1.3 v41.9h56.4v-2.9c0-0.2,0-0.4-0.2-0.4L55.7,44.8c-0.2-0.7-0.9-0.7-1.1-0.7h-4.9v-9.6l9.6-4.5l11.4,16.5c0.2,0.2,0.7,0.4,0.9,0.7 c0.4,0,0.7,0,1.1-0.2c0.4-0.2,0.7-0.7,0.7-0.9c0-0.4,0-0.7-0.2-0.9L62.9,30.3h12.9c0.7,0,1.3-0.7,1.3-1.3V14 C77.4,13.3,76.7,12.6,75.8,12.6z M53.9,46.8l0.2,0.2l25.2,37.5H29V46.8H53.9z M74.5,27.1H58.8c-0.2,0-0.4,0-0.4,0L47.9,32 c-0.7,0.2-0.9,0.9-0.9,1.1v10.7H35.4v-8.7c0-0.4-0.2-0.9-0.4-1.1L23.8,22.7l9.6-7.4h40.8v11.8H74.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNettoyage);
export default __webpack_public_path__ + "static/media/nettoyage.6cce9b1db9068b52b229dd1ebee8cef8.svg";
export { ForwardRef as ReactComponent };